import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // if using react-router
// or use window.location if no router

function BlueskyCallbackReturn() {
  const [token, setToken] = useState (null);
  const [error, setError] = useState (null);
  const [loading, setLoading] = useState(true);

  const location = useLocation(); // if using react-router
  const navigate = useNavigate(); // if using react-router

  useEffect(() => {
    const extractToken = () => {
      try {
        // Option 1: From query string (?token=...)
        const params = new URLSearchParams(location.search);
        let receivedToken = params.get('token');

        // Option 2: From hash fragment (#token=...) – more secure as it doesn't hit server
        if (!receivedToken && location.hash) {
          const hashParams = new URLSearchParams(location.hash.substring(1));
          receivedToken = hashParams.get('token');
        }

        if (receivedToken) {
  setToken(receivedToken);
  
  // SEND TO BACKEND
  fetch('https://api.schedpilot.com/wp-json/api/v1/register-bluesky-token', {
    method: 'POST',
     credentials: 'include', 
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      token: receivedToken,
      handle: params.get('handle') // Ensure you pass the handle back from the URL
    })
  }).then(res => res.json())
    .then(data => console.log("Stored on server:", data));
}
 else {
          setError('No token received in the URL. Authentication may have failed.');
        }
      } catch (err) {
        setError('Error processing authentication response.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    extractToken();
  }, [location]);

  const handleGoBack = () => {
    navigate('/'); // or wherever your main dashboard is
  };

  const handleClose = () => {
    window.close(); // if opened in new tab/popup
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h2>Processing Bluesky authentication...</h2>
        <p>Please wait a moment.</p>
      </div>
    );
  }

  return (
    <div style={{
      maxWidth: '500px',
      margin: '50px auto',
      padding: '30px',
      border: '1px solid #ddd',
      borderRadius: '12px',
      textAlign: 'center',
      fontFamily: 'system-ui, sans-serif'
    }}>
      <h1 style={{ color: token ? '#2ecc71' : '#e74c3c' }}>
        {token ? 'Bluesky Connected!' : 'Authentication Issue'}
      </h1>

      {token ? (
        <>
          <p style={{ fontSize: '1.1em', margin: '20px 0' }}>
            Your Bluesky account is now linked successfully.
          </p>



          <p style={{ color: '#666', fontSize: '0.9em' }}>
            Token stored. You can now schedule posts and manage your Bluesky account from SchedPilot.
          </p>

          <div style={{ marginTop: '30px' }}>
            <button
              onClick={handleGoBack}
              style={{
                padding: '12px 24px',
                fontSize: '1.1em',
                marginRight: '15px',
                background: '#1da1f2',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Back to Dashboard
            </button>

            <button
              onClick={handleClose}
              style={{
                padding: '12px 24px',
                fontSize: '1.1em',
                background: '#95a5a6',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Close Window
            </button>
          </div>
        </>
      ) : (
        <>
          <p style={{ color: '#e74c3c', fontSize: '1.1em' }}>
            {error || 'Something went wrong during authentication.'}
          </p>
          <p>Please try connecting again or contact support if the issue persists.</p>

          <button
            onClick={handleGoBack}
            style={{
              padding: '12px 24px',
              fontSize: '1.1em',
              marginTop: '20px',
              background: '#e74c3c',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Return to App
          </button>
        </>
      )}
    </div>
  );
}

export default BlueskyCallbackReturn;